export default {
    page: {
        account_exists: {
            text: 'Il semblerait que vous ayez déjà un compte.',
            button: 'Continuer sur mon compte'
        },
        existing_page: {
            title: 'Choisir une entreprise existante.',
            button: 'Continuer avec cette entreprise'
        }
    },
    success: 'Vous êtes maintenant inscrit !'
};